/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_4_P1Inputs */



/**
* | output |
* | --- |
* | "Liability for damages from simple negligence is excluded, unless essential contractual obligations are violated. In case of violation of essential contractua..." |
*
* @param {Guardrails_Section_4_P1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_4_p1 = /** @type {((inputs?: Guardrails_Section_4_P1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_4_P1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Haftung für Schäden aus leichter Fahrlässigkeit ist ausgeschlossen, soweit nicht wesentliche Vertragspflichten (Kardinalpflichten) verletzt werden. Bei Verletzung wesentlicher Vertragspflichten ist die Haftung auf den vertragstypisch vorhersehbaren Schaden begrenzt.")
	return /** @type {LocalizedString} */ ("Liability for damages from simple negligence is excluded, unless essential contractual obligations are violated. In case of violation of essential contractual obligations, liability is limited to typically foreseeable damages.")
});